import Vue from 'vue';
import { loadLanguage } from '@/core/i18nUtils';
import createStore from '../store';

export default (i18n) => {
  const MainPageTransaction = () => import('./MainPageTransaction');
  const vue = new Vue({
    el: '#mainpage-transaction',
    i18n,
    template: '<MainPageTransaction />',
    components: {
      MainPageTransaction,
    },
    store: createStore(),
    data() {
      return {
        loadedI18n: false,
      };
    },
    render(h) {
      if (this.loadedI18n) {
        return h(MainPageTransaction);
      }
      return h('p', '');
    },
    async beforeCreate() {
      await loadLanguage(this, [
        'main',
        'find',
        'transaction',
      ]);

      switch (window.lang) {
        case 'english': this.$i18n.locale = 'en'; break;
        case 'gb': this.$i18n.locale = 'gb'; break;
        default: this.$i18n.locale = 'zh';
      }
      this.loadedI18n = true;
    },
  });

  return vue;
};

